<template>
    <div>
        <input :type="type" :placeholder="placeholder" :maxlength="maxlength" :value="value" :required="isRequired" :disabled="isDimmed" @input="$emit('update:value', $event.target.value)"/>
    </div>
</template>

<script>
/* 2021.04.13 - Nam Sang Woo
 * app-input 컴포넌트
 * type: email, password, text
 * attr: placeholder, maxlength, required, disabled
 * description: input 텍스트, 이메일, 패스워드에 대한 스타일, 값 제어
 */
export default {
    name: "appInput",
    props: {
        type: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        maxlength: {
            type: Number,
        },
        isRequired:{
            type:Boolean,
            required:false
        },
        isDimmed:{
            type:Boolean,
            required:false
        },
        value:{
            type: String,
        }
    }
};
</script>

<style lang="scss" scoped>
.warnning{
  input{
    border: 1px solid #F7685B;

    &:focus{
      border-color:#F7685B;
    }
  }
}

input {
  width: 100%;
  height: 44px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding:11px;
  border-radius: 8px;
  border: 1px solid #E9E9E9;
  background-color: #ffffff;
  text-align: left;
  color: #3D4E67;
  font-weight: 400;
  font-size: 13px;
  box-sizing: border-box;
  outline: none;

  &:focus{
    background-color: #ffffff;
    color:#3D4E67;
    border-color:#90A0B7;
  }

  &::placeholder{
    color:#C0C0C0;
    font-size:13px;
  }

  &:disabled{
    background-color: #EFEFEF;
    border-color: #DADADA;
    color:#A6A6A6;
  }

  &:disabled::placeholder{
    color:#A6A6A6;
  }
}
</style>